<template>
  <div class="container" @click="$emit('click')">
    <div v-if="$slots.headerButton" class="Header-Button-Wrapper">
      <slot name="headerButton" />
    </div>
    <div class="Text-Title" :style="backgroundStyle">
      {{ title }}
    </div>
    <div class="Toast">
      <div class="Text-Container">
        <span class="Text Time" v-if="secondary">
          {{ secondary }}
        </span>
      </div>
      <div class="Icon-Container" v-if="status">
        <img :src="icon" :alt="title" />
      </div>
    </div>
  </div>
</template>

<script>
import unstarted from '@/assets/status/noncommenc@3x.png'
import pending from '@/assets/status/encours@3x.png'
import finished from '@/assets/status/finished@3x.png'

export default {
  name: 'VvMobileTile',
  props: {
    title: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false,
      validator(val) {
        return !val || ['unstarted', 'running', 'finished'].includes(val)
      }
    }
  },
  computed: {
    icon() {
      if (this.status === 'finished') return finished

      if (this.status === 'running') return pending

      return unstarted
    },
    backgroundStyle() {
      return this.image ? `background: center / cover no-repeat url(${this.image})` : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.container {
  background-color: inherit;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: flex-end;
  border-radius: 8px;
  padding-bottom: 1px;
  overflow: hidden;
  width: 100%;
  height: 170px;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.9);
  box-shadow: inset 0px 0 200px 5px rgba(0, 0, 0, 0.7), 0 3px 10px rgba(216, 216, 216, 0.5);
  transition: all 200ms linear;

  &:hover {
    box-shadow: inset 0px 0 200px 5px rgba(0, 0, 0, 0.7), 3px 6px 13px rgba(216, 216, 216, 0.8);
  }

  .Header-Button-Wrapper {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .Text-Title {
    align-self: center;
    text-align: center;
    vertical-align: middle;
    margin: auto;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    width: 100%;
    height: 170px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: inset 0px 0 200px 5px rgba(0, 0, 0, 0.7), 0 3px 10px rgba(216, 216, 216, 0.5);
    transition: all 200ms linear;
    border-radius: 8px 8px 0px 0px;
  }

  .Toast {
    width: 100%;
    background-color: #fff;
    display: flex;
    color: $font-color;
    align-items: center;
    border-radius: 0px 0px 8px 8px;
    box-shadow: 0px 10px 3px 10px rgba(0,0,0,0.01);
    transition: all 200ms linear;

    .Text-Container {
      width: 100%;
      text-align: left;
      box-sizing: border-box;

      .Time {
        align-self: flex-start;
        margin-left: 10px;
        font-size: 11px;
        font-weight: normal;
      }
    }

    .Icon-Container {
      display: inline-block;
      text-align: right;
      margin-right: 5px;
      margin-top: 5px;
      width: 10%;

      img {
        height: 15px;
        width: 15px;
      }
    }
  }
}
</style>
